<div id="notfound-wrapper" class="notfound-page">
  <div class="mui-card notfound-page__card">
    <h1 class="mmu-move__card-title">{{ 'global.appTitle' | translate }}</h1>
    <h2 class="notfound-page__title">{{ 'error404Page.title' | translate }}</h2>
    <svg class="notfound-page__image" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 403 203">
      <g fill="none" fill-rule="evenodd">
        <path
          fill="#ECECEC"
          fill-rule="nonzero"
          d="M260.935 5.3c25.6 4.915 53.74 12.832 65.905 27.846 12.345 15.015 8.714 37.265 1.997 56.51-6.9 19.247-17.248 35.49-29.776 50.096-12.709 14.605-27.778 27.572-46.478 39.448-18.7 11.875-41.213 22.931-64.09 23.75-23.057.82-46.66-8.599-61.91-22.112-15.07-13.514-21.787-31.122-28.686-46.546-6.9-15.288-14.162-28.528-21.06-44.635-6.9-16.244-13.618-35.353-4.177-47.502 9.26-12.148 34.86-17.335 56.828-23.75 22.15-6.416 40.85-14.196 61.729-17.063 20.879-2.866 44.118-.955 69.718 3.959z" />
        <g class="right-plug">
          <path fill="#B9B9B9" d="M226.047 126c14.36 0 26-10.074 26-22.5s-11.64-22.5-26-22.5" />
          <path stroke="#B9B9B9" stroke-linecap="square" stroke-width="4" d="M209.047 93h20m-20 21h20" />
          <path
            stroke="#B9B9B9"
            stroke-linecap="square"
            stroke-width="3"
            d="M247.547 105.98c7.354-1.333 19.116-2 35.286-2 24.255 0 24.255-29.98 49.521-29.98 23.839 0 19.693 29.98 40.85 29.98 14.103 0 23.233-6.833 27.39-20.5" />
        </g>
        <g class="left-plug">
          <path fill="#B9B9B9" d="M175.547 126c-14.36 0-26-10.074-26-22.5s11.64-22.5 26-22.5" />
          <path
            stroke="#B9B9B9"
            stroke-linecap="square"
            stroke-width="3"
            d="M155.047 103.5c-7.354 1.333-19.116 2-35.286 2-24.255 0-24.255 29.98-49.521 29.98-23.839 0-19.693-29.98-40.849-29.98C15.287 105.5 6.157 112.333 2 126" />
        </g>
        <g class="bling" stroke="#CBCBCB" stroke-linecap="round" stroke-width="2">
          <path d="M173,52.5l10,10 M200,32.5v28 M173,151.5l10-10 M200,171.5v-28 M225.5,53l-10,10 M225.5,151l-10-10" />
        </g>
      </g>
    </svg>
    <span class="notfound-page__message">{{ 'error404Page.message' | translate }}</span>
    <a mui-btn appearance="primary" class="notfound-page__redirect-link" href="/">{{ 'error404Page.backBtn' | translate }}</a>
  </div>
</div>
